const _excluded = ["setEnabled"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { useGetAllPaginatedData, CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { useContextWithValidation, getOrCreateGlobalContext } from '@adsk/alloy-react-context';
import { useCurrentProjectId } from './CurrentProjectIdContext';
import { removeOldDuplicatesBy } from './helpers/removeOldDuplicatesBy';
import useClientSideDataModification from './hooks/useClientSideDataModification';
/**
 * Context for companies list.
 */
const CompaniesContext = getOrCreateGlobalContext(CONTEXT_NAMES.CompaniesContext);
const useCompaniesContext = () => useContextWithValidation(CompaniesContext, {
  hook: 'useCompanies',
  provider: 'CompaniesProvider'
});
export const useCompanies = () => {
  const _useCompaniesContext = useCompaniesContext(),
    {
      setEnabled
    } = _useCompaniesContext,
    rest = _objectWithoutProperties(_useCompaniesContext, _excluded);
  useEffect(() => {
    if (setEnabled) {
      setEnabled(true);
    }
  }, [setEnabled]);
  return rest;
};
const PAGE_LIMIT = 200;
export const CompaniesProvider = _ref => {
  let {
    children
  } = _ref;
  const [enabled, setEnabled] = useState(false);
  const projectId = useCurrentProjectId();
  const adminApiUrl = getAdminApiUrl();
  const url = enabled && projectId ? "".concat(adminApiUrl, "/v1/projects/").concat(projectId, "/companies?limit=").concat(PAGE_LIMIT) : '';
  const {
    loading: loadingData,
    error,
    data: dataFromBE,
    retry,
    clearSessionStorage
  } = useGetAllPaginatedData({
    url
  });
  const companiesFromBE = useMemo(() => {
    return dataFromBE && removeOldDuplicatesBy(dataFromBE.flatMap(page => page.results), item => item.id);
  }, [dataFromBE]);
  const {
    modifyData,
    addData: addCompanies,
    updateEntity: updateCompany,
    removeEntityById: removeCompanyById
  } = useClientSideDataModification(clearSessionStorage);
  const loading = loadingData || !enabled;
  const data = useMemo(() => modifyData(companiesFromBE), [modifyData, companiesFromBE]);
  const value = useMemo(() => ({
    data,
    loading,
    error,
    retry,
    addCompanies,
    updateCompany,
    removeCompanyById,
    setEnabled: enabled ? undefined : setEnabled
  }), [addCompanies, updateCompany, data, error, loading, removeCompanyById, retry, enabled]);
  return /*#__PURE__*/React.createElement(CompaniesContext.Provider, {
    value: value
  }, children);
};
CompaniesProvider.displayName = 'CompaniesProvider';
CompaniesProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node
};
//# sourceMappingURL=CompaniesContext.js.map